import { Grommet } from "grommet";
import { appTheme } from "./theme";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, Switch, } from "react-router-dom";
import { PrivateLayout, PublicLayout } from "./layouts";
import { useEffect } from "react";
import { NotificationProvider } from "./components/admin/NotificationContext";
import { ConnectNotificationSocket } from "./services/socket";
import { useThemeMode } from "./components/theme";

const App = (
	{ authenticated, checked, access }
) => {
	const { themeMode } = useThemeMode();
	useEffect(() => {
		if (access) ConnectNotificationSocket(access);
	}, [access])
	return (
		<Grommet theme={appTheme} themeMode={themeMode} full>
			<Router basename="/competitive">
				<Switch>
					<Route path='/embed'><PublicLayout /> </Route>
					<NotificationProvider>
						<Route path='/'><PrivateLayout authenticated={authenticated} checked={checked} /> </Route>
					</NotificationProvider>
				</Switch>
			</Router>
		</Grommet >
		// <Grommet theme={hpe} full>
		// 	<Security oktaAuth={oktaAuth}>
		// 		<Router>
		// 			<Switch>
		// 				<Route path='/index' component={LandingPage} />
		// 				<Route path='/login' component={LoginPage} />
		// 				<SecureRoute exact path='/' component={CompetitorDashboard} />
		// 				<SecureRoute exact path='/dashboard' component={Dashboard} />
		// 				{/* <SecureRoute exact path='/calendar' component={StorageCalendar} />
		// 				<SecureRoute exact path='/product-group/:id' component={ProductGroup} />
		// 				<SecureRoute exact path='/product-group/:product_group_id/demo/:id' component={Demo} />
		// 				<SecureRoute exact path='/:product_group_id/demo/:id' component={Demo} />
		// 				<SecureRoute exact path='/learn-more' component={HelpPage} />
		// 				<SecureRoute exact path='/competitor' component={CompetitorDashboard} />
		// 				<SecureRoute exact path='/competitor/:id' component={CompetitorProductListPage} />
		// 				<SecureRoute exact path='/tools/:id&:name' component={CompetitorProductListPage} /> */}
		// 				{/* <SecureRoute exact path='/competitor/:id/:product_id/resource-center' component={CompetitorResourceCenter} /> */}
		// 				{/* <SecureRoute exact path='/competitor/:id/:product_id/resource-center/:res_id' component={CompetitorBattleCards} />
		// 				<SecureRoute exact path="/competitor/notification-center" component={NotificationCenter} />
		// 				<SecureRoute exact path='/competitor/admin-report' component={CompetitorReportPage} />
		// 				<SecureRoute exact path='/admin-dash' component={AdminDashboard} />
		// 				<SecureRoute exact path='/admin-manager' component={AdminDataManager} /> */}
		// 				<Redirect from="/" to="/index" />
		// 				<Route component={PageNotFound} />
		// 			</Switch>
		// 		</Router>
		// 	</Security>
		// </Grommet>
	);
};

const { bool } = PropTypes;

App.propTypes = {
	authenticated: bool.isRequired,
	checked: bool.isRequired,
};

const mapState = ({ session }) => ({
	checked: session.checked,
	authenticated: session.authenticated,
	access: session.user ? session.user.access : null,
});

export default connect(mapState)(App);

